import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

const ResetDialog = ({ open, onClose, onConfirm, aircraftType, saving }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Reset Baseline to Defaults?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will remove all custom baseline values for <strong>{aircraftType}</strong> and restore the hard-coded defaults from the system.
          This action cannot be undone. Are you sure you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button onClick={onConfirm} color="warning" variant="contained" disabled={saving}>
          Reset to Defaults
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetDialog;
